var httpr = require('@syyx/httpr')
module.exports = httpr.init()